export type Pagination = {
  page_number: number;
  page_size: number;
};

export const getPagination = (
  pageNumber: number,
  pageSize: number
): Pagination => ({
  page_number: pageNumber,
  page_size: pageSize,
});
